import { css, type Theme } from "@emotion/react";

export const clearAll = css`
  margin-top: 1rem;
  text-align: end;
`;

export const excludedTag = (theme: Theme) => css`
  width: 100%;
  justify-content: space-between;

  border-color: ${theme.warning.borderBase};
  background-color: ${theme.warning.backgroundMuted};

  &:first-of-type {
    margin-top: 1rem;
  }

  &:not(:first-of-type) {
    margin-top: 0.5rem;
  }

  &:hover {
    border-color: ${theme.warning.borderActive};
  }
`;
